<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="Bullet_Hole-4.html" xml:lang="en-US">
<div class="calibre1">
<p class="ct" id="toc_marker-5"><a href="#/OEBPS/Bullet_Hole2#Contents-A">Epigraph</a></p>
<p class="quote">‘The only way,’ I said to Alexander, ‘of really finding out a man’s true character is to play golf with him. In no other walk of life does the cloven hoof so quickly display itself.’</p>
<p class="quote-by">P.G. Wodehouse: <em class="italic">Ordeal By Golf</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Bullet_Hole-4.vue?e94efe98